import Box from "@mui/material/Box";

/* Shared status/outcome vocabulary + chip for internal-appraisal review orders.
   Used by the loan Orders tab, the order detail drawer, and the queue screen so
   colors/labels stay in sync. */

export const APPRAISAL_STATUS_META = {
  // Not a backend status — the Orders tab uses it for a subject property that
  // has no review order yet.
  // Rendered as a plain grey pill: no status dot, fully rounded.
  not_ordered: {
    label: "Not ordered",
    fg: "#6b7480",
    bg: "#eef1f4",
    dot: null,
    pill: true,
  },
  queued: { label: "Queued", fg: "#475569", bg: "#eef2f4", dot: "#94a3b8" },
  assigned: { label: "Assigned", fg: "#1d4ed8", bg: "#e8efff", dot: "#3b82f6" },
  in_review: {
    label: "In review",
    fg: "#92600a",
    bg: "#fef3e2",
    dot: "#d97f0d",
  },
  completed: {
    label: "Completed",
    fg: "#0f6e56",
    bg: "#e1f5ee",
    dot: "#10916f",
  },
  cancelled: {
    label: "Cancelled",
    fg: "#a32d2d",
    bg: "#f5eceb",
    dot: "#c0716e",
  },
};

// ObjectIds arrive as plain strings or Mongo extended-JSON ({ $oid }).
const oidStr = (v) => {
  if (v == null) return null;
  if (typeof v === "object") return v.$oid || v._id || null;
  return String(v);
};

// Every appraisal on an order. `appraisalDocOids` (list, backend 2026-09-11)
// is authoritative; orders created before it only carry the singular
// `appraisalDocOid`, and the model returns the list empty for those — so fall
// back to the singular one. Always returns a de-duplicated string array.
export const orderAppraisalDocOids = (order) => {
  const list = Array.isArray(order?.appraisalDocOids)
    ? order.appraisalDocOids
    : [];
  const source = list.length > 0 ? list : [order?.appraisalDocOid];
  return [...new Set(source.map(oidStr).filter(Boolean))];
};

export const APPRAISAL_OUTCOME_LABEL = {
  approved: "Approved",
  approved_with_conditions: "Approved with conditions",
  revision_requested: "Revision requested",
  rejected: "Rejected",
};

export const AppraisalStatusChip = ({ status }) => {
  const m = APPRAISAL_STATUS_META[status] || {
    label: status || "—",
    fg: "#697680",
    bg: "#eef2f4",
    dot: "#aab4bb",
  };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        // fontSize: 12,
        // fontWeight: 600,
        fontSize: 11,
        fontWeight: 500,
        // color: slate[600],
        // color: m.fg,
        background: m.bg,
        borderRadius: m.pill ? "999px" : "6px",
        px: m.pill ? "11px" : "9px",
        py: m.pill ? "4px" : "3px",
        whiteSpace: "nowrap",
      }}
    >
      {m.dot && (
        <Box
          component="span"
          sx={{ width: 6, height: 6, borderRadius: "50%", background: m.dot }}
        />
      )}
      {m.label}
    </Box>
  );
};
